type SortableItem = {id: string, description: string};

export const sortNewsletterItems = (
    items: SortableItem[],
    isDisabled?: (id: string) => boolean,
): SortableItem[] => [...items].sort((a, b) => {
    if (isDisabled) {
        const aDisabled = isDisabled(a.id);
        const bDisabled = isDisabled(b.id);
        if (aDisabled !== bDisabled) {
            return aDisabled ? 1 : -1;
        }
    }
    return a.description.localeCompare(b.description);
});
